module.exports = __webpack_public_path__ + "static/media/tracking-rabbit-logo.bdd54e55.png";